import { reducer } from '@/components/draft/draftState/reducer';
import { DraftReducer } from '@/components/draft/draftState/types';
import { addHistoryEntry } from './draftHistory';

export const reducerWithHistory: DraftReducer = (draft, action) => {
  const updatedDraft = reducer(draft, action);
  if (draft !== updatedDraft) {
    addHistoryEntry(action, draft);
  }

  return updatedDraft;
};
